export default "__VITE_ASSET__Lgo6z59F__"